<div class="disable-full-screen" [style.opacity]="modal.is_active ? 100 : 0" [style.visibility]="modal.is_active ? 'visible' : 'hidden'">
  <div class="background" (click)="closeModal()"></div>
  <div class="container-center">
    <div class="modal">
      <div class="modal-header">
        <div class="modal-header-left">
          <div class="modal-header-txt">
            <ng-container *ngIf="currentStep === 1">Partition Arming</ng-container>
            <ng-container *ngIf="currentStep === 2">
              Select partitions to&nbsp;<span [style.color]="pendingSiteAction === 1 ? '#ff7f16' : '#1ea675'">{{ pendingSiteAction === 1 ? 'ARM' : 'DISARM' }}</span>
            </ng-container>
          </div>
        </div>
        <div style="position:relative">
          <div class="title-close"><i class="material-icons" (click)="closeModal()">close</i></div>
        </div>
      </div>

      <div class="items-area" style="overflow-y: initial;">

        <!-- Step 1 -->
        <ng-container *ngIf="currentStep === 1">
          <div *ngIf="canChangePartitionArmingStatus()" class="item">
            <div class="arming-wrapper">
              <div class="site-arming-button" [class.disabled]="hasAnySyncing()" (click)="startSiteAction(1)">
                <comp-icon class="icon" [icon]="'armed'" [color]="'#ff7f16'" [size]="24"></comp-icon><span>Site Arm</span>
              </div>
              <div class="site-arming-button" [class.disabled]="hasAnySyncing()" (click)="startSiteAction(2)">
                <comp-icon class="icon" [icon]="'disarmed'" [color]="'#1ea675'" [size]="24"></comp-icon><span>Site Disarm</span>
              </div>
            </div>
          </div>
          <div *ngIf="!canChangePartitionArmingStatus()" class="item">
            <div class="permission-info">
              <comp-icon class="icon" [icon]="'info'" [color]="'#ff7f16'" [size]="20"></comp-icon>
              <span>You do not have permission to change partition arming status</span>
            </div>
          </div>
          <div class="item" style="margin-top: 20px;">
            <div class="f-1 item-label">Partitions</div>
            <div class="partition-arming-wrapper">
              <div
                class="partition-card"
                *ngFor="let partition of partitions"
                [class.armed]="getPartitionStatus(partition) === 'ARMED'"
                [class.disarmed]="getPartitionStatus(partition) === 'DISARMED'"
                [class.unknown]="getPartitionStatus(partition) === 'UNKNOWN'"
                [class.disabled]="isReadonlyPartition(partition) || !canChangePartitionArmingStatus() || hasAnySyncing()"
                [class.syncing]="isSyncing(partition.partition_id)"
                (click)="!isReadonlyPartition(partition) && onPartitionClick(partition)">
                <div class="partition-card-top">
                  <span class="partition-name">{{partition.name || 'No name'}}</span>
                  <div class="partition-card-top-right">
                    <div *ngIf="partition.arming_source === 2" class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'bottom-left')">
                      <comp-icon [icon]="'error'" [size]="'20'" [color]="'#ffffff'"></comp-icon>
                      <div class="--g-tooltip tooltip-background" style="text-transform: none;">Alarm Panel Pairing</div>
                    </div>
                    <img *ngIf="partition.arming_source === 4" class="arming-source-logo" src="/assets/logo/adc_logo.png" alt="ADC"/>
                    <img *ngIf="partition.arming_source === 5" class="arming-source-logo" src="/assets/logo/oe_logo.png" alt="OE"/>
                    <div class="partition-spinner" *ngIf="isSyncing(partition.partition_id)"></div>
                  </div>
                </div>
                <div class="partition-card-bottom">
                  <comp-icon class="icon"
                    [icon]="getPartitionStatus(partition) === 'DISARMED' ? 'disarmed' : getPartitionStatus(partition) === 'UNKNOWN' ? 'unknown_arming' : 'armed'"
                    [color]="'white'"
                    [size]="20"></comp-icon>
                  <span class="partition-status-text">{{getPartitionStatus(partition)}}</span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Step 2 -->
        <ng-container *ngIf="currentStep === 2">
          <div class="step2-label-row" style="margin-bottom: 12px;">
            <div class="f-1 item-label">Partitions</div>
            <div class="select-all-wrapper" (click)="toggleSelectAll()">
              <div class="select-all-circle" [class.selected]="isAllSelected()">
                <i class="material-icons select-all-check" *ngIf="isAllSelected()">check</i>
              </div>
              <span class="select-all-text">Select All</span>
            </div>
          </div>
          <div class="partition-arming-wrapper step2-wrapper">
            <div
              class="partition-card"
              *ngFor="let partition of partitions"
              [class.armed]="getPartitionStatus(partition) === 'ARMED'"
              [class.disarmed]="getPartitionStatus(partition) === 'DISARMED'"
              [class.unknown]="getPartitionStatus(partition) === 'UNKNOWN'"
              [class.step2-selected]="isStep2Selected(partition.partition_id)"
              [class.step2-disabled]="isStep2Disabled(partition)"
              (click)="!isStep2Disabled(partition) && toggleStep2Selection(partition.partition_id)">
              <div class="partition-card-top">
                <span class="partition-name">{{partition.name || 'No name'}}</span>
                <div class="partition-card-top-right">
                  <div *ngIf="partition.arming_source === 2" class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'bottom-left')">
                    <comp-icon [icon]="'error'" [size]="'20'" [color]="'#ffffff'"></comp-icon>
                    <div class="--g-tooltip tooltip-background" style="text-transform: none;">Alarm Panel Pairing</div>
                  </div>
                  <img *ngIf="partition.arming_source === 4" class="arming-source-logo" src="/assets/logo/adc_logo.png" alt="ADC"/>
                  <img *ngIf="partition.arming_source === 5" class="arming-source-logo" src="/assets/logo/oe_logo.png" alt="OE"/>
                </div>
              </div>
              <div class="partition-card-bottom">
                <comp-icon class="icon"
                  [icon]="getPartitionStatus(partition) === 'DISARMED' ? 'disarmed' : getPartitionStatus(partition) === 'UNKNOWN' ? 'unknown_arming' : 'armed'"
                  [color]="'white'"
                  [size]="20"></comp-icon>
                <span class="partition-status-text">{{getPartitionStatus(partition)}}</span>
              </div>
              <div class="step2-check"
                *ngIf="!isStep2Disabled(partition)"
                [class.checked]="isStep2Selected(partition.partition_id)"
                [class.check-armed]="getPartitionStatus(partition) === 'ARMED'"
                [class.check-disarmed]="getPartitionStatus(partition) === 'DISARMED'">
                <i class="material-icons">check</i>
              </div>
            </div>
          </div>
        </ng-container>

      </div>

      <div class="tail-btn-area">
        <ng-container *ngIf="currentStep === 1">
          <div class="button" (click)="closeModal()">
            <div class="btn-inner">Close</div>
          </div>
        </ng-container>
        <ng-container *ngIf="currentStep === 2">
          <div class="button button-primary" [class.disabled]="step2SelectedIds.length === 0" (click)="applyStep2()">
            <div class="btn-inner">Apply</div>
          </div>
          <div class="button" (click)="backToStep1()">
            <div class="btn-inner">Back</div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<dealer-warning [modal]="m_warning" [doCancel]="m_warning.data['doCancel']"></dealer-warning>
